<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h3>Hedge Parameter</h3>
          <p v-if="loadsWithoutUnit.length == 0">
            Bestimmen Sie die folgenden Parameter um mit dem Hedgen
            fortzufahren.
          </p>
          <p v-else>
            Bestimmen Sie die folgenden Parameter und ergänzen Sie die fehlenden
            Einheiten, bei den unten aufgelisteten Lastgängen, um mit dem Hedgen
            fortzufahren.
          </p>
          <form @submit.prevent="hedge()">
            <label>Zeitraum:</label>
            <select v-model="params.products" required>
              <option v-for="p in products" :value="p.value" :key="p.text">
                {{ p.text }}
              </option>
            </select>
            <label>Blöcke:</label>
            <select v-model="params.blocks" required>
              <option v-for="b in blocks" :key="b">
                {{ b }}
              </option>
            </select>
            <!-- Display only if loads without unit -->
            <div v-for="load in loadsWithoutUnit" :key="load.name" class="load">
              <label
                >Einheit für die Zeitreihe {{ load.series[0].caption }}:</label
              >
              <select v-model="load.series[0].unit" required>
                <option v-for="u in units" :key="u">
                  {{ u }}
                </option>
              </select>
            </div>
            <div class="footer">
              <button class="btn-green" type="submit">Speichern</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hedgeParamsModal',
  data() {
    return {
      units: ['kWh', 'kW'],
      blocks: ['Base', 'Base-Peak'],
      products: [
        { value: 'Months', text: 'Monate' },
        { value: 'Quarters', text: 'Quartale' },
        { value: 'Years', text: 'Jahre' },
      ],
    };
  },
  props: {
    loadsWithoutUnit: Array,
    params: Object,
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    hedge: function () {
      this.$emit('hedge', this.hedgeParams);
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    hedgeParams() {
      return this.params;
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 40%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: fixed;
  left: 30%;
  top: 12%;
  height: 495px;
  overflow-y: scroll;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: #70787e;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}

select {
  width: 70%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 13px;
  line-height: 21px;
  color: #70787e;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

button {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 20px;
  margin-right: 30px;
}

label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 80%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  height: 65px;
  width: 105%;
}

.switch-group > label.caption {
  float: left;
  height: 53px;
  padding-top: 19px;
}

.radioOption {
  width: 100%;
}

.radioOption input {
  border: 0;
  background: transparent;
}

.radioOption input[type='text'] {
  width: 68%;
  margin-left: 9px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.radioOption input[type='radio'] {
  width: 21px;
  float: left;
  margin-bottom: 0;
  height: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}
</style>
